// ══════════════════════════════════════════════════════════════════════
// 💬 SOHBET YUVASI — UYGULAMA ÖMRÜ BOYUNCA TEK KOPYA
// ══════════════════════════════════════════════════════════════════════
// App.js'te <Routes> DIŞINDA render edilir. Böylece sayfa değişince
// sökülmez: WebSocket bağlı kalır, mesaj geçmişi korunur, sunucuya
// gezinme başına 1 soket + 4 istek yükü BİNMEZ.
//
// Görsel yapı (aside genişliği, konumu, aç/kapa sekmesi) eski sayfa-içi
// haliyle BİREBİR aynıdır; yalnızca nerede yaşadığı değişti.
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { LiveChat } from './LiveChat';
import { useChatLayout } from '../context/ChatLayoutContext';

export const ChatDock = () => {
  const { chatOpen, setChatOpen, toggleChat } = useChatLayout();
  return (
    <>
      {/* MOBİL KAPLAMA — dokununca sohbeti kapatır.
          ⚠️ Bu davranış eskiden YALNIZCA Home'da vardı; sohbet tek yere
          taşındığı için artık TÜM sayfalarda mobilde açılabilir. */}
      {chatOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-[55] backdrop-blur-sm md:hidden"
          onClick={() => setChatOpen(false)}
        />
      )}

      <aside
        data-testid="chat-sidebar"
        className={`flex flex-col fixed left-0 top-16 md:top-20 bottom-0 w-[85%] sm:w-[300px] lg:w-[330px] z-[60] md:z-30 bg-[#191b1e] border-r border-[#2A2D31] transition-transform duration-300 ${chatOpen ? 'translate-x-0' : '-translate-x-full'}`}
        style={{ boxShadow: '8px 0 24px -10px rgba(0,0,0,0.55)' }}
      >
        <div className="pointer-events-none absolute top-0 inset-x-0 h-4 bg-gradient-to-b from-black/55 to-transparent z-40" />
        <LiveChat />
      </aside>

      <button
        onClick={toggleChat}
        aria-label={chatOpen ? 'Close chat' : 'Open chat'}
        className={`hidden md:flex fixed top-1/2 -translate-y-1/2 z-40 w-6 h-20 items-center justify-center rounded-r-lg bg-[#1f2226] border border-l-0 border-[#2A2D31] text-zinc-400 hover:text-white hover:bg-[#23262a] transition-all duration-300 ${chatOpen ? 'left-[300px] lg:left-[330px]' : 'left-0'}`}
      >
        {chatOpen ? <ChevronLeft className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
      </button>
    </>
  );
};
